import { Typography, Descriptions, Table, Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import ShareHoldingService from '../../services/ShareHoldingService';

const { Text, Title } = Typography;

const ShowDetail = ({ tradingAccountNo }) => {
  const [tradingAccountDetail, setTradingAccountDetail] = useState();

  console.log(tradingAccountNo);

  const fetchData = async () => {
    const result = await ShareHoldingService.getTradingAccountDetail({ tradingAccountNo });

    setTradingAccountDetail(result.data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const assetDataListColumn = [
    {
      title: 'Security Code',
      dataIndex: 'securityCode',
      key: 'securityCode',
    },
    {
      title: 'Symbol Code',
      dataIndex: 'symbolCode',
      key: 'symbolCode',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Selling Power',
      dataIndex: 'sellingPower',
      key: 'sellingPower',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Holding Quantity',
      dataIndex: 'holdingQuantity',
      key: 'holdingQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
  ];

  const assetDataList = tradingAccountDetail ? tradingAccountDetail.assetDataList : [];

  console.log(assetDataList);

  return (
    <>
      {/* Detail Information */}
      <Descriptions>
        <Descriptions.Item label="Trading Account No">
          <Text strong>{tradingAccountDetail?.tradingAccountNo}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Trading Account Type">
          <Text strong>{tradingAccountDetail?.tradingAccountType}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Currency">
          <Text strong>{tradingAccountDetail?.currency}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Bank Balance">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.bankBalance).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Buying Power">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.buyingPower).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Reserved Fee Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.reservedFeeAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Placed Order Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.placedOrderAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Debit Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.debitAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        {/* Add more properties as needed */}
      </Descriptions>
      <Title level={5} style={{ margin: '2rem 0 1rem 0' }}>
        Asset List
      </Title>
      {/* <Divider /> */}
      <Table
        columns={assetDataListColumn}
        dataSource={assetDataList.map(asset => ({ ...asset, key: asset.assetId }))}
        size="small"
        scroll={{ x: 600 }}
        bordered
      />
    </>
  );
};

export default ShowDetail;
